import { getMonolithUrls } from '../../utils';

export interface IFooterLink {
  name: string;
  path: string;
  dataTestId: string;
}

type IFooterLinks = Array<{
  name: string;
  items: IFooterLink[];
}>;

export function getFooterLinks(baseUrl: string) {
  const monolithUrls = getMonolithUrls(baseUrl);

  return [
    {
      name: 'Marketplace',
      items: [
        {
          name: 'Buy Now',
          path: monolithUrls.fixedPriceUrl,
          dataTestId: 'fixed-price',
        },
        {
          name: 'Auction',
          path: monolithUrls.weeklyAuctionUrl,
          dataTestId: 'weekly',
        },
        {
          name: 'Premier',
          path: monolithUrls.premierAuctionUrl,
          dataTestId: 'premier',
        },
        {
          name: 'Sold items',
          path: monolithUrls.salesHistoryUrl,
          dataTestId: 'sales-history',
        },
      ],
    },
    {
      name: 'Services',
      items: [
        {
          name: 'Private sales',
          path: monolithUrls.privateSalesUrl,
          dataTestId: 'private-sales',
        },
        {
          name: 'Dealer program',
          path: monolithUrls.dealerProgram,
          dataTestId: 'dealer-program',
        },
        {
          name: 'Eye Appeal',
          path: monolithUrls.eyeAppealUrl,
          dataTestId: 'eye-appeal',
        },
        {
          name: 'Affiliates',
          path: monolithUrls.affiliates,
          dataTestId: 'affiliates',
        },
        {
          name: 'Sell your cards',
          path: monolithUrls.sellYourCards,
          dataTestId: 'sell-your-cards',
        },
      ],
    },
    {
      name: 'Support',
      items: [
        {
          name: 'How it works',
          path: monolithUrls.aboutTheMarketplaceUrl,
          dataTestId: 'how-it-works',
        },
        {
          name: 'Help center',
          path: monolithUrls.helpCenterUrl,
          dataTestId: 'help-center',
        },
        {
          name: 'Newsroom',
          path: monolithUrls.newsroomUrl,
          dataTestId: 'newsroom',
        },
        {
          name: 'Definitive guides',
          path: monolithUrls.definitiveGuidesUrl,
          dataTestId: 'def-guides',
        },
        {
          name: "What's new",
          path: monolithUrls.whatsNew,
          dataTestId: 'whats-new',
        },
      ],
    },
    {
      name: 'Also from Fanatics',
      items: [
        {
          name: 'Fanatics',
          path: monolithUrls.fanaticsUrl,
          dataTestId: 'fanatics',
        },
        {
          name: 'Fanatics Live',
          path: monolithUrls.fanaticsLiveUrl,
          dataTestId: 'fanatics-live',
        },
        {
          name: 'Fanatics Markets',
          path: monolithUrls.fanaticsMarkets,
          dataTestId: 'fanatics-markets',
        },
        {
          name: 'Fanatics Sportsbook',
          path: monolithUrls.fanaticsSportsbookUrl,
          dataTestId: 'fanatics-sportsbook',
        },
        {
          name: 'Topps',
          path: monolithUrls.toppsUrl,
          dataTestId: 'topps',
        },
      ],
    },
  ] satisfies IFooterLinks;
}
